// Hummin — Lenis smooth scroll initializer
// Desktop only (>=1024px), respects prefers-reduced-motion.
// Lenis itself is loaded via CDN in theme.liquid before this script.

(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.innerWidth < 1024) return;
  if (typeof Lenis === 'undefined') return;

  const lenis = new Lenis({
    duration: 1.0,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smoothWheel: true,
    smoothTouch: false,
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);
})();
